import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { record, text } from '../studio/studio-content';
import { photoPolicy, photoValues } from './photo-model';
/** Карточка итога «Стиль «Ретро-кадр» · Как у фото · 4 фото»: снимок входа заказа (display), иначе — выбор формы этого заказа. */
export function photoResultCard(state: CircleFormState): string {
  const display = record(record(state.order).display);
  const inputs = (state.intent?.body.inputs ?? state.inputs ?? {}) as Record<string, unknown>;
  const policy = state.form ? photoPolicy(state.form) : null;
  const reference = record(display.reference).kind === 'reference' || (typeof inputs.reference === 'string' && !!inputs.reference);
  const styleId = typeof inputs.style === 'string' ? inputs.style : '';
  const styleName =
    text(record(display.style).name) || text(display.style_name) || (policy?.styles.find(style => style.id === styleId)?.name ?? '');
  const style = reference ? 'Свой референс' : styleId === 'none' ? 'Без стиля' : styleName ? `Стиль «${styleName}»` : '';
  const formatId = typeof inputs.format === 'string' ? inputs.format : '';
  const format = text(display.format) || photoValues[formatId] || '';
  const count = Number(record(state.order).variants ?? display.count ?? inputs.count ?? 0);
  return [style, format, count > 0 ? `${count} фото` : ''].filter(Boolean).join(' · ');
}
